import styled from 'styled-components'
import theme from 'theme_'

export const PaymentMethodCardsUl = styled.ul<{ $isFullPage?: boolean }>`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: ${theme.spacing.xs};
  ${(p) => p.$isFullPage && `flex-wrap: wrap`};

  @media ${theme.devices.tablet} {
    gap: 16px;
  }
`

export const PaymentMethodCardLi = styled.li<{ $isFullPage?: boolean }>`
  width: ${(p) => (p.$isFullPage ? '100%' : `calc(45% - 8px)`)};
  min-width: 275px;
  flex-shrink: 0;
  padding-bottom: ${theme.spacing.xs};

  @media ${theme.devices.tablet} {
    ${(p) =>
      p.$isFullPage &&
      `
      width: 322px;
    `}
  }
`
